var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"download-row"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('Button',{attrs:{"variety":"primary-text","loading":_vm.loading},on:{"click":_vm.handleClick}},[_vm._v("Download")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }